// extracted by mini-css-extract-plugin
export default {"searchArea":"Tree_searchArea__sKTJw","treeArea":"Tree_treeArea__9AVl4"};